import React from 'react';

export function IpRulesPanel({ ipRules, onChange }) {
  const list = ipRules.list.join('\n');

  function setList(text) {
    const entries = text
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean);
    onChange({ ...ipRules, list: entries.length ? entries : ['0.0.0.0/0', '::/0'] });
  }

  return (
    <div className="panel-section">
      <div className="radio-row">
        <label className="radio-item">
          <input type="radio" checked={ipRules.mode === 'allow'} onChange={() => onChange({ ...ipRules, mode: 'allow' })} />
          Allow list
        </label>
        <label className="radio-item">
          <input type="radio" checked={ipRules.mode === 'deny'} onChange={() => onChange({ ...ipRules, mode: 'deny' })} />
          Deny list
        </label>
      </div>
      <p className="panel-help">
        One CIDR per line. <code>0.0.0.0/0</code> and <code>::/0</code> mean "all IPv4 / all IPv6".
      </p>
      <textarea
        rows={4}
        value={list}
        onChange={(e) => setList(e.target.value)}
        placeholder="0.0.0.0/0&#10;::/0"
      />
    </div>
  );
}
